const normalizeWyiwyg = (content: string) => {
    const slideshows = content.match(/<p><button\s+data-slideshow-id="\d+">EDITAR\s+SLIDESHOW<\/button><\/p>/g);
    let updatedContent = content
    if(slideshows){
        slideshows.forEach((slideshow: string) => {
            const slideshowNumber = slideshow.match(/data-slideshow-id="(\w+)"/)
            if(!slideshowNumber) return
            updatedContent = updatedContent.replace(slideshow, `<!-- monclova-slideshow-${slideshowNumber[1]} -->`)
        })
    }

    return updatedContent
}

const wyiwygToHtml = (content: string) => {
    const slideshows = content.match(/<!-- monclova?-slideshow-\w+ -->/g)
    let updatedContent = content
    if(slideshows){
        slideshows.forEach((slideshow: string) => {
            const slideshowNumber = slideshow.match(/monclova-slideshow-(\w+)/)
            if(!slideshowNumber) return
            updatedContent = updatedContent.replace(slideshow, `<p><button data-slideshow-id="${slideshowNumber[1]}">EDITAR SLIDESHOW</button></p>`)
        })
    }
    return updatedContent
}

export {
    normalizeWyiwyg,
    wyiwygToHtml
}